/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';

import {
    SORTING_ORDER,
    COLUMNS_NAMES,
    ORDERED_HEADER_COLUMNS,
} from '../../common/utils/studentsSortingHelpers';
import { localize } from '../../common/localization';

const getColumnWraperClassNames = columnName =>
    classNames(
        // HACK: empty string is added for correct prefixing
        // issue https://github.com/vezetvsem/react-classname-prefix-loader/issues/3
        'dashboard-students-list-header-column',
        'dashboard-' +
            columnName
                .toLowerCase()
                .split(' ')
                .join('-'),
    );

const StudentsListHeader = ({ selectedAppGroup, sortingParams, changeSortingOrder }) => {
    const getColumnsClassNames = columnName => {
        // Sorting arrows are visible only at the column that is selected for the primary sorting.
        // In sortingParams we have such column as first element
        const { column, order } = sortingParams[0];

        return classNames('dashboard-column-name', {
            'dashboard-asc': columnName === column && order === SORTING_ORDER.ASC,
            'dashboard-desc': columnName === column && order === SORTING_ORDER.DESC,
        });
    };

    const headerColumns = useMemo(
        () =>
            ORDERED_HEADER_COLUMNS[selectedAppGroup].filter(columnName =>
                sortingParams.some(({ column }) => column === columnName),
            ),
        [selectedAppGroup, sortingParams],
    );

    const columnNames = columnName => {
        const { DIBELS, IDEL2 } = COLUMNS_NAMES;

        if (columnName === DIBELS) {
            return <span>{columnName}&reg;8</span>;
        }

        if (columnName === IDEL2) {
            return <span>Lectura</span>;
        }
        return localize(columnName);
    };

    const onColumnClick = useCallback(columnName => () => changeSortingOrder(columnName), [
        changeSortingOrder,
    ]);

    const onColumntKeyPresses = useCallback(
        columnName => event => (event.key === 'Enter' ? changeSortingOrder(columnName) : null),
        [changeSortingOrder],
    );

    return (
        <div className='dashboard-students-list-header'>
            {headerColumns.map(columnName => {
                const styleName = columnName === COLUMNS_NAMES.IDEL2 ? 'Lectura' : columnName;
                // The reasone behind this ^^ is that in ratio IDEL2: 'Spanish R&D' string 'Spanish R&D' has forbiten symbol '&' for naming style classes
                // Consider that in the future 'Spanish R&D' will be changed to 'Lectura' so lets rename style class to match this change
                // If we apply IDEL2: 'Lectura' - remove this statement and use columnName

                return (
                    <div className={getColumnWraperClassNames(styleName)} key={styleName}>
                        <div
                            className='dashboard-student-list-header-items-container'
                            tabIndex={0}
                            onKeyDown={onColumntKeyPresses(columnName)}
                        >
                            <div
                                className={getColumnsClassNames(columnName)}
                                onClick={onColumnClick(columnName)}
                            >
                                {columnNames(columnName)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

StudentsListHeader.propTypes = {
    selectedAppGroup: PropTypes.string.isRequired,
    changeSortingOrder: PropTypes.func.isRequired,
    sortingParams: PropTypes.array.isRequired,
};

export default memo(StudentsListHeader);
